import { useEffect, useState } from "react";

export default function SplashScreen() {
  const [visible, setVisible] = useState(() => !sessionStorage.getItem("riddhi_splash_seen"));

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => {
      setVisible(false);
      sessionStorage.setItem("riddhi_splash_seen", "1");
    }, 1800);
    return () => clearTimeout(t);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100] splash-bg flex items-center justify-center splash-fade" data-testid="splash-screen">
      <div className="flex flex-col items-center px-8">
        <img
          src="https://customer-assets.emergentagent.com/job_riddhi-elegance/artifacts/8b0yz6uh_ffaab141-db10-4f1b-8d78-dd8685cdd1f1.jpg"
          alt="Riddhi"
          className="w-[min(560px,85vw)] h-auto object-contain splash-logo"
        />
        <div className="mt-6 h-px w-16 bg-[#E9C97A]/50 splash-rule" />
      </div>
    </div>
  );
}
